import { useEffect, useState } from "react";
import { authenticationApi } from "@rshbintech.dboul/http";
import { Button, Dialog, Heading, Text } from "@rshbintech.dboul/core-ui";
import { OwnFarmLogo as OwnFarmingLogoImage } from "@rshbintech.dboul/images";
import { useAppTranslation } from "../../../hooks";
import { DEFAULT_OWN_FARMING_URL } from "./constants";
import { OwnFarmingDialogProps } from "./types";
import styles from "./styles.scss";

export const OwnFarmingDialog = ({
  isOwnFarmingDialogOpen,
  onOwnFarmingDialogClose,
}: OwnFarmingDialogProps) => {
  const [forwardURL, setForwardURL] = useState(DEFAULT_OWN_FARMING_URL);
  const { translate } = useAppTranslation("MENU");

  const getForwardURL = async () => {
    try {
      const { data } = await authenticationApi.api.getSsoAccessTokenByRefresh({
        callbackURI: "/auth?auth=authsb",
        partnerName: "farming",
      });

      setForwardURL(data.forwardURL);
    } catch (error) {
      setForwardURL(DEFAULT_OWN_FARMING_URL);
    }
  };

  useEffect(() => {
    if (forwardURL !== DEFAULT_OWN_FARMING_URL || !isOwnFarmingDialogOpen) {
      return;
    }

    getForwardURL();
  }, [isOwnFarmingDialogOpen]);

  const handleProceed = () => {
    window.open(forwardURL);
    onOwnFarmingDialogClose?.();
  };

  return (
    <Dialog
      size="medium"
      opened={isOwnFarmingDialogOpen}
      onClose={onOwnFarmingDialogClose}
    >
      <div className={styles.container}>
        <OwnFarmingLogoImage className={styles["own-farming-logo"]} />
        <Heading className={styles.header} level={3}>
          {translate("OWN_FARMING_DIALOG_DICTIONARY.HEADER_TEXT")}
        </Heading>
        <Text className={styles.content}>
          {translate("OWN_FARMING_DIALOG_DICTIONARY.CONTENT_TEXT")}
        </Text>
        <footer className={styles.footer}>
          <Button
            htmlType="button"
            data-rptracker-event="click"
            data-rptracker-category="dboSvoefermerstvo"
            data-rptracker-action="svoefermerstvoClickConfirmed"
            onClick={handleProceed}
          >
            {translate("OWN_FARMING_DIALOG_DICTIONARY.PROCEED_BUTTON_TEXT")}
          </Button>
        </footer>
      </div>
    </Dialog>
  );
};
